const Impressum = () => (
  <div className="impressum_content">
    <h2>Impressum</h2>
    <h3>Unternehmensangaben</h3>
    <p>
      Patrick Wollner<br />
      1070 Wien
    </p>
    <h3>Kontaktinformationen</h3>
    <p>
      E-Mail: <a href="mailto:contact@pwollner.com">contact@pwollner.com</a>
    </p>
    <h3>Unternehmensinformationen</h3>
    <p>
      UID-Nr.: ATU70172403<br />
      Mitgliedschaft: Mitglied der WKÖ
    </p>
    <h3>Berufsrecht</h3>
    <p>
      Gewerbeordnung: Gewerbeordnung
    </p>
    <h3>Aufsichtsbehörde</h3>
    <p>
      Magistratisches Bezirksamt für den 6. und 7. Bezirk Wien
    </p>
    <h3>Online-Streitbeilegung</h3>
    <p>
      Beschwerden können an die Online-Streitbeilegungsplattform der EU gerichtet werden: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">Online-Streitbeilegungsplattform</a><br />
      Alternativ können Sie Beschwerden auch an die oben angegebene E-Mail-Adresse richten.
    </p>
  </div>
)

export default Impressum 